import { getDashboardGrounding } from 'apis/dashboardApis'
import { quickSearch } from 'apis/vehicleApis'
import { AVAILABLE_INVENTORY_INIT_QUERY } from 'common/constants'
import { IDashboardVehicles, ISearchFilterResult } from 'types/vehicleTypes'
import create from 'zustand'
import { useGlobalStore } from './useGlobalStore'
import { Rules } from 'common/rules'

export interface IDashBoardDataState {
  groundingData: IDashboardVehicles
  fetchGroundingData: () => Promise<void>
  filters: ISearchFilterResult[]
  totalVehicles: number
  fetchFilters: () => Promise<void>
}

export const useDashboardStore = create<IDashBoardDataState>((set, get) => ({
  groundingData: {} as IDashboardVehicles,

  fetchGroundingData: async () => {
    if (useGlobalStore.getState().isInRule(Rules.VIEW_GROUNDING_ACTIVITY)) {
      const resp = await getDashboardGrounding()
      if (resp) {
        set((state) => ({ ...state, groundingData: resp }))
      }
    }
  },
  filters: [],
  totalVehicles: 0,

  fetchFilters: async () => {
    const allowRules = [Rules.PAGE_RDP_SRP, Rules.VIEW_ADVANCED_SEARCH_PAGE]
    if (allowRules?.some((rule) => useGlobalStore.getState().isInRule(rule))) {
      const resp = await quickSearch({ ...AVAILABLE_INVENTORY_INIT_QUERY })

      if (resp) {
        set((state) => ({
          ...state,
          filters: [...resp.Data] as ISearchFilterResult[],
          totalVehicles: resp.TotalRecords
        }))
        return
      }
    }
    set((state) => ({
      ...state,
      filters: [] as ISearchFilterResult[],
      totalVehicles: 0
    }))
  }
}))
